import Table from "@material-ui/core/Table";
import TableContainer from "@material-ui/core/TableContainer";
import ContentTitle from "components/common/ContentTitle";
import Steper from "components/common/Steper";
import ButtonController from "components/request-document/components/ButtonController";
import { useStyles } from "components/request-document/components/Commons";
import HealthInsurance from "components/request-document/components/HealthInsurance";
import dayjs from "dayjs";
import { useFormik } from "formik";
import { REQUEST_DOCUMENT_STEP } from "libs/configs/constant";
import { SMART_T_STEP } from "libs/constant/Step";
import useModalLoading from "libs/hooks/useModalLoading";
import { get } from "lodash-es";
import mime from "mime";
import { React, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addHealthInsurance,
  getHealthInsuranceList,
  healthInsuranceAddSlice,
  healthInsuranceListSlice,
  selectAddHealthInsurance,
  selectListHealthInsurance,
} from "redux/modules/healthInsuranceSlice";
import { selectPersonalDetail } from "redux/modules/personalSlice";
import { setSmartFormStep } from "redux/modules/uiSlice";
import { selectDraftId } from "redux/modules/visaForm";
import * as yup from "yup";
import { canEditForm } from "redux/modules/authSlice";

export default function HealthInsuranceStep() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { showLoading, hideLoading } = useModalLoading();
  const [isSaveDraft, setSaveDraft] = useState(true);
  const [isFirstTimeFetching, setFirstTimeFetching] = useState(true);
  const canEdit = useSelector(canEditForm);
  const personalDetail = useSelector(selectPersonalDetail);
  const draftId = useSelector(selectDraftId);
  const healthInsuranceListState = useSelector(selectListHealthInsurance);
  const healthInsuranceAddState = useSelector(selectAddHealthInsurance);

  const personalId = get(personalDetail, "personalID", "");
  const healthInsuranceList = get(healthInsuranceListState, "list", []);

  useEffect(() => {
    if (draftId && personalId && isFirstTimeFetching) {
      setFirstTimeFetching(false);
      dispatch(getHealthInsuranceList({ personalID: personalId, draftId }));
      showLoading();
    }
  }, [personalId, draftId, dispatch, showLoading, isFirstTimeFetching]);

  useEffect(() => {
    if (!healthInsuranceListState.isLoading) {
      if (healthInsuranceListState.isSuccess) {
        hideLoading();
        dispatch(healthInsuranceListSlice.actions.clearAsyncState());
      } else if (healthInsuranceListState.isFailure) {
        hideLoading();
        alert(healthInsuranceListState.error?.message);
        dispatch(healthInsuranceListSlice.actions.clearAsyncState());
      }
    }
  }, [
    healthInsuranceListState.isLoading,
    healthInsuranceListState.isSuccess,
    healthInsuranceListState.isFailure,
    healthInsuranceListState.error?.message,
    hideLoading,
    dispatch,
  ]);

  useEffect(() => {
    if (!healthInsuranceAddState.isLoading) {
      if (healthInsuranceAddState.isSuccess) {
        hideLoading();
        dispatch(healthInsuranceAddSlice.actions.clearAsyncState());
        dispatch(getHealthInsuranceList({ personalID: personalId, draftId }));
        if (!isSaveDraft) {
          dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_DOCUMENT));
        }
      } else if (healthInsuranceAddState.isFailure) {
        hideLoading();
        alert(healthInsuranceAddState.error?.message);
        dispatch(healthInsuranceAddSlice.actions.clearAsyncState());
      }
    }
  }, [
    dispatch,
    draftId,
    healthInsuranceAddState.error?.message,
    healthInsuranceAddState.isFailure,
    healthInsuranceAddState.isLoading,
    healthInsuranceAddState.isSuccess,
    hideLoading,
    isSaveDraft,
    personalId,
  ]);

  const callAPISubmit = async (values) => {
    showLoading();

    const HealthInsuranceList = values.HealthInsuranceList;
    const prepareData = HealthInsuranceList[HealthInsuranceList.length - 1];

    await dispatch(addHealthInsurance(prepareData));
  };

  const mapHealthInsurance = (field) => ({
    healthID: field.healthID || null,
    personalID: field.personalID || null,
    draftId: field.draftId || null,
    expDate: field.expDate ? dayjs(field.expDate).format("YYYY-MM-DD") : "",
    FileID: field.fileID || "",
    Status: field.status || true,
    file: field.fileID
      ? new File([new Blob()], `${field.filename}${field.ext}`, {
        type: mime.getType(field.ext),
      })
      : {},
    disabled: field.draftId ? field.draftId !== draftId : false,
  });
  const validationSchema = yup.object({});
  const formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      HealthInsuranceList:
        healthInsuranceList.length === 0
          ? [
            {
              healthID: null,
              personalID: personalId,
              draftId: draftId,
              expDate: "",
              FileID: null,
              Status: true,
              // --
              file: {},
            },
          ]
          : healthInsuranceList.map(mapHealthInsurance),
    },
    onSubmit: async (values) => {
      setSaveDraft(false);
      callAPISubmit(values);
    },
  });

  return (
    <div className={classes.root}>
      <form onSubmit={formik.handleSubmit}>
        <ContentTitle
          title="Application Form"
          subTitle="APPLICATION FOR QUALIFICATION ENDORSEMENT FOR SMART VISA “S”"
        />
        <Steper currentStep={1} stepInfo={REQUEST_DOCUMENT_STEP} />
        <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
          <Table className={classes.table}>
            <HealthInsurance colSpan={4} formik={formik} />
          </Table>
        </TableContainer>
        <ButtonController
          onClickSaveDraft={() => {

            if (!canEdit) {
              dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_DOCUMENT));
              return;
            }
            setSaveDraft(true);
            callAPISubmit(formik.values);
          }}
        />
      </form>
    </div>
  );
}
